import ProjectListColumns from './ProjectListColumns';

export default ProjectListColumns;
